import React,{Component}from 'react';
import { Icon ,Tooltip,Whisper} from 'rsuite';

class SlidebarItem extends Component {
    constructor(props){
        super(props);
    }
    tooltip(){
        return(
        <Tooltip>{this.props.content}</Tooltip>
        )
    }
    render() {
        return (
            <Whisper placement="right" 
                trigger="hover"
                speaker={this.tooltip()}>
            <div 
                id={this.props.id} 
                className="item" 
                onClick={this.props.onClick}
                
            >
                <Icon 
                    icon={this.props.icon} 
                    className="icon"
                    id={this.props.id}
                />
                
            </div>
            </Whisper>
        )
    }
}

export default SlidebarItem;